import { useMutation, useQueryClient } from 'react-query';
import { EditingStylesApi } from '../../EditingStylesApi';
import { ListEditingStylesQueryKey } from '../../queryKeys';
import { CreateEditingStyleInput, EditingStyle } from '../../types';

export type CreateEditingStyle = (input: CreateEditingStyleInput) => Promise<EditingStyle>;

export function useCreateEditingStyleMutation(): CreateEditingStyle {
    const queryClient = useQueryClient();

    const mutation = useMutation<EditingStyle, unknown, CreateEditingStyleInput>(
        (input) => EditingStylesApi.createEditingStyle(input),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([ListEditingStylesQueryKey]);
            }
        }
    );

    return function createEditingStyle(input: CreateEditingStyleInput) {
        return mutation.mutateAsync(input);
    };
}
